import { createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../../services";
import { fetchDataAxios } from "../../../apiConfig";

export const usersThunk = createAsyncThunk(
  "/users",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/users`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const getAllUsersThunk = createAsyncThunk(
  "/getAllUsers",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/getAllUsers`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const addUsersThunk = createAsyncThunk(
  "/saveOrUpdateUser",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/saveOrUpdateUser`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);

export const getAllSkillsThunk = createAsyncThunk(
  "/getAllSkills",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await postData(`/getAllSkills`, {
        ...productRequest,
      });
      return result.data.response;
    } catch (err) {
      return rejectWithValue({ error: err?.response?.data });
    }
  }
);
